import { LightShowSegment } from './lightshow-segment';
import { LightShowOperation } from '../Operations/lightshow-operation';
import { PlayAudioOperation } from '../Operations/play-audio-operation';

export class AudioSegment extends LightShowSegment {

  public init() {
    this.color = 'orange';
    this.minDuration = 100;
    this.enableSegmentGrips = false;
  }

  public addOperations(operations: LightShowOperation[]) {
    operations.push(new PlayAudioOperation(this.position, this.duration, this.audioUrl, this.segmentId));
  }
}
